export const addDotBtnsAndClickHandlers = (emblaApi, dotsNode) => {
    let dotNodes = []

    // Hjelpefunksjon for å formatere tekst med variabler
    const formatDotText = (template, current, total) => {
        return template.replace('{0}', current).replace('{1}', total);
    }

    const addDotBtnsWithClickHandlers = () => {
        const totalSlides = emblaApi.scrollSnapList().length;
        const gotoTemplate = dotsNode.dataset.dotTextGoto;

        dotsNode.innerHTML = emblaApi
            .scrollSnapList()
            .map((_, index) => {
                const slideNumber = index + 1;
                return `
                    <button 
                        class="embla__dot" 
                        type="button"
                        aria-label="${formatDotText(gotoTemplate, slideNumber, totalSlides)}"
                        aria-current="false"
                    ></button>
                `;
            })
            .join('')

        const scrollTo = (index) => {
            emblaApi.scrollTo(index)
        }

        dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'))
        dotNodes.forEach((dotNode, index) => {
            dotNode.addEventListener('click', () => scrollTo(index), false)
        })
    }

    const toggleDotBtnsActive = () => {
        const previous = emblaApi.previousScrollSnap()
        const selected = emblaApi.selectedScrollSnap()
        const totalSlides = dotNodes.length;
        const gotoTemplate = dotsNode.dataset.dotTextGoto;
        const currentTemplate = dotsNode.dataset.dotTextCurrent;

        // Oppdater forrige valgte dot
        dotNodes[previous].classList.remove('embla__dot--selected')
        dotNodes[previous].setAttribute('aria-current', 'false')
        dotNodes[previous].setAttribute('aria-label',
            formatDotText(gotoTemplate, previous + 1, totalSlides))

        // Oppdater nåværende valgte dot
        dotNodes[selected].classList.add('embla__dot--selected')
        dotNodes[selected].setAttribute('aria-current', 'true')
        dotNodes[selected].setAttribute('aria-label',
            formatDotText(currentTemplate, selected + 1, totalSlides))
    }

    emblaApi
        .on('init', addDotBtnsWithClickHandlers)
        .on('reInit', addDotBtnsWithClickHandlers)
        .on('init', toggleDotBtnsActive)
        .on('reInit', toggleDotBtnsActive)
        .on('select', toggleDotBtnsActive)

    return () => {
        dotsNode.innerHTML = ''
    }
}